// extracted by mini-css-extract-plugin
module.exports = {"hidden":"infoChallenge_hidden__vHVl4","textEmphasis":"infoChallenge_textEmphasis__Aff3x","challengeInfo":"infoChallenge_challengeInfo__9wmjA"};